import React from 'react'

interface Props {
  title: string
  subTitle: string
}

const Breadcrumbs = ({title, subTitle}: Props) => {
  return (
    <div className='d-flex flex-stack container-fluid mb-5 ps-0' id='kt_app_toolbar_container'>
      <div className='d-flex flex-column'>
        <span className='fs-3 fw-bold text-gray-900'>{title}</span>
        <span className='text-gray-500 fw-semibold lh-20px fs-7'>{subTitle}</span>
      </div>
    </div>
  )
}

export default Breadcrumbs
